<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Charges"
            bc1="App"
            bc2="Charges"
            bc3="List"
            path="charges"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class="m-2">
            <div class="row">
              <div class="col-md-12 col-12">
                <div class="d-flex align-items-center justify-content-end">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="$router.push({ name: 'add-charges' })"
                  >
                    <AddButtonText name="Charge" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <CommonTable
            :url="url"
            :tableHeaderValues="tableHeaderValues"
            :actions="actions"
            :deleteActions="deleteActions"
            :mutedData="mutedData"
            :storageKey="storageKey"
            :externalTotalRecord="externalTotalRecord"
            :show-per-page="true"
          />
        </div>
      </div>
    </div>
    <ChargesDetailsModal  :data="detailsData"
                                  :show="showDetailsModal"
                                  @hide="showDetailsModal = false" />
  </div>
  <!-- END: Content-->
</template>

<script>
import { CommandIcon } from "vue-feather-icons";
import ChargesDetailsModal from "@/pages/dashboard/charges/chargesDetailsModal.vue";
import DetailsModal from "@/components/common/modals/RefundRequestsModals/refundDetailsModal.vue";
import AddButtonText from "@/components/common/buttons/AddButtonText.vue";

export default {
  components: {
    AddButtonText,
    DetailsModal,
    ChargesDetailsModal,
    CommandIcon
  },
  mounted() {
    localStorage.setItem("url", "v1/get-charges");
    this.checkDataInStore('v1/get-charges')
    if (
      typeof this.$route.params.update == "undefined" &&
      typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      url: "v1/get-charges",
      storageKey: "charges",
      detailsData: [],
      showDetailsModal: false,
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "name"
        },
        {
          title: "Type",
          valueKey: "type",
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="badge-light-primary badge">${value}</span>`;

              if(value.toUpperCase() == 'CARD'){
                html = `
                <div class="row">
                    <div class="col-12 ">
                       ${html}
                       <br>
                        <div class="badge badge-dark mt-1" style="cursor: pointer;">Show Charges Details</div>
                    </div>
                </div>
                `
              }
              return html;
            } else {
              html = "-";
              return html;
            }
          },
          cta: (row) => {
            if(row.type.toUpperCase() == 'CARD'){
              this.detailsData = row.id
              this.showDetailsModal = true
            }
          }
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function(value, row) {
            var html = "";
            if (value == 1) {
              html = `<span class="badge badge-success badge-sm">Active</span>`;
            } else {
              html = `<span class="badge badge-danger badge-sm">Inactive</span>`;
            }
            if (row.is_default == 1) {
              html += '<span class="badge badge-secondary ml-1">Default</span>';
            }
            return html;
          }
        }
      ],
      actions: [
        {
          title: "update",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "chargesUpdate"
            };
            this.$store.dispatch("set", data);
            this.$router.push({ name: "update-charges" });
          }
        }
      ],
      deleteActions: [
        {
          title: "Delete",
          class: " ml-1 custom-control-primary",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "chargeDelete"
            };
            this.deleteRecord(data);
          }
        }
      ],
      mutedData: [],
      externalTotalRecord: ""
    };
  },
  methods: {
    //deleteRecord(row) {
    //  this.makeRequest("post", "v1/delete-charge", {
    //    status: row.status == true ? 1 : 0,
    //    id: row.id
    //  });
    //},
    deleteRecord(data) {
      this.makeRequest("post", "v1/delete-charge", {
        status: data.row.status == true ? 1 : 0,
        id: data.row.id
      }).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let storeData = this.$store.getters.getByKey("charges");
            if (storeData != null) {
              if (typeof storeData.firstPageData != "undefined") {
                if (
                  typeof storeData.firstPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.firstPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.firstPageData.data[data.index] = data.row;
                    delete storeData.otherPageData;
                  }
                }
              }
              if (typeof storeData.otherPageData != "undefined") {
                if (
                  typeof storeData.otherPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.otherPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.otherPageData.data[data.index] = data.row;
                  }
                }
              }
              storeData.key = "charges";
              this.$store.dispatch("set", storeData);
            }
          }
        }
      });
    }
  }
};
</script>

